export default __webpack_public_path__ + "static/soc2-f40d7177e84251f874c6d451983e4576.svg";